import Engine, { Bundle } from '@ali/visualengine';
import React from 'react';
import Icon from './logo.tsx';
import DataSourceSetter from '@/common/setter/datasource-setter/datasource-setter';

import {
  generateIndex,
  getDataSourceList,
  getDsNameFromVariable,
  removeDataSourceByNode,
} from '@/common/util/util';
import { getItemInitialValue } from '@/common/manager/filter-item';
import {
  createFormDefaultValueSetters,
  createFormItemSetters,
} from '../cn-form-alc/prototype/form-item';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { createEventSetters } from '@/common/manager/event';
import DocLinkSetter from '@/common/setter/doc-link-setter';
import {
  getLabelAlignSetterSnippet,
  getObjectSetterSnippet,
} from '@/common/manager/setter-snippet';
import { getBizExtendPrototype } from '@/common/manager/plugin';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import IdSetter from '@/common/setter/id-setter';
import { CnIcon } from '@cainiaofe/cn-ui';
import { createButtonListSetters } from '@/common/manager/button';

const { ActionSetter } = window.VisualEngineUtils || {};

const filterBundle = Bundle.createPrototype({
  title: '筛选栏（CnFilter）',
  componentName: 'CnFilter',
  category: 'FTP场景（列表页）',
  enableCopy: true,
  // disableBehaviors: ['copy'],
  icon: Icon,
  docUrl:
    'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
  isContainer: false,
  // experimental:{
  //   callbacks: {
  //     onNodeRemove: (dragment, self) => {
  //     }
  //   },
  // },
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/tfs/TB1gaZrr.T1gK0jSZFhXXaAtVXa-1048-366.png',
      label: 'CnFilter',
      schema: {
        componentName: 'CnFilter',
        props: {},
      },
    },
  ],
  onNodeRemoveByUser(node) {
    // removeDataSourceByNode(node);
  },
  configure: [
    {
      name: 'isCnFilter',
      title: 'isCnFilter',
      initialValue: true,
      display: 'none',
    },
    {
      name: 'title',
      title: '筛选栏名称',
      display: 'inline',
      initialValue: '筛选栏1',
      tip: '当前筛选栏的名称，方便检索使用',
      setter: 'StringSetter',
    },
    {
      name: 'doc',
      title: '使用文档',
      display: 'inline',
      setter: (
        <DocLinkSetter
          link={
            'https://alidocs.dingtalk.com/i/nodes/NkPaj7GAXdpWOkPeZ6p0Wqwgylnomz9B?iframeQuery=anchorId%3Dlc5uji34n8fs2ylqgaa'
          }
          content={'点击查看筛选栏的正确使用姿势'}
        />
      ),
    },
    {
      name: 'config',
      title: '筛选项配置',
      display: 'accordion',
      initialValue: [
        getItemInitialValue({
          position: DisplayPosition.filter,
        }),
      ],
      setter: createFormItemSetters({ position: DisplayPosition.filter }),
      // supportVariable: true,
    },

    // {
    //   name: 'config',
    //   title: '筛选项配置',
    //   initialValue: [{
    //     label:'名称',
    //     name:'name',
    //     componentName:'Input',
    //   }],
    //   setter: (
    //     <ListSetter
    //       checkField={null}
    //       addable={true}
    //       deletable={true}
    //       editable
    //       draggable={true}
    //       display={'drawer'}
    //       configure={[
    //         {
    //           name: 'label',
    //           display: 'inline',
    //           title: '字段名称',
    //           initialValue(){
    //             if(this.initialData) {
    //               return this.initialData;
    //             }
    //             const existFields = this.props?.parent?.prop?.getValue() || [];
    //             const defaultFieldName = '文本';
    //             const newFieldIndex = generateIndex(existFields, defaultFieldName, 'label')
    //             return `${defaultFieldName}${newFieldIndex}` || defaultFieldName
    //           },
    //           setter: <TextSetter />,
    //           editable: true,
    //         },
    //         {
    //           name: NAME,
    //           display: 'inline',
    //           title: '字段编码',
    //           initialValue(){
    //             if(this.initialData) {
    //               return this.initialData;
    //             }
    //             const existFields = this.props?.parent?.prop?.getValue() || [];
    //             const defaultFieldName = 'field';
    //             const newFieldIndex = generateIndex(existFields, defaultFieldName, 'name')
    //             return `${defaultFieldName}${newFieldIndex}` || defaultFieldName
    //           },
    //           setter: <TextSetter />,
    //           editable: true,
    //         },
    //         {
    //           name: 'componentName',
    //           display: 'inline',
    //           title: '组件类型',
    //           initialValue: 'Input',
    //           mutator(value){
    //             // FIXME
    //             // 兼容写法，ListSetter里的mutator有缺陷，其他属性改的时候也会触发当前属性的mutator
    //             const hotData = this?.getHotData();
    //             let oldValue;
    //             try {
    //               const temp = JSON.parse(hotData)
    //               oldValue = temp?.value;
    //             }catch (e){
    //             }
    //             if(value !== oldValue){
    //               const allProps = this.getParamList().toParams();
    //               let newFilterItemProps = getCnFilterItemProps(allProps)
    //               const componentDefine = getFilterItem(value)
    //               const componentInitialValue = componentDefine?.getInitialValue?.();
    //               if(componentInitialValue){
    //                 newFilterItemProps = {...newFilterItemProps,...componentInitialValue}
    //               }
    //               this.getParamList().setParams(newFilterItemProps)
    //             }
    //             return value;
    //           },
    //           setter: <SelectSetter
    //             options={filterItemList}
    //             compact={false}
    //           />,
    //         },
    //         ...getFilterItemPrototypeList(),
    //         {
    //           title: '样式',
    //           type:'group',
    //           display: 'accordion',
    //           collapsed:true,
    //         },
    //         {
    //           name: 'span',
    //           display: 'inline',
    //           title: '网格数',
    //           initialValue: 1,
    //           // setter: <NumberSetter min={1} max={2} />,
    //           setter:<ChoiceSetter
    //             options={[{
    //               title: '1格',
    //               value: 1,
    //             },{
    //               title: '2格',
    //               value: 2,
    //             }]}
    //             compact={false}
    //           />,
    //         },
    //         {
    //           name: 'required',
    //           display: 'inline',
    //           title: '是否必填',
    //           // supportVariable: true,
    //           setter: <BoolSetter />,
    //         },
    //         {
    //           name: 'requiredMessage',
    //           display: 'inline',
    //           title: '必填提示',
    //           tip:'未填写时报的错误提示文案',
    //           // supportVariable: true,
    //           setter: <TextSetter />,
    //         },
    //         // {
    //         //   name: 'hidden',
    //         //   title: '是否隐藏',
    //         //   display: 'inline',
    //         //   // supportVariable: true,
    //         //   setter: <BoolSetter />,
    //         // },
    //         {
    //           name: 'placeholder',
    //           title: '空提示',
    //           display: 'inline',
    //           // supportVariable: true,
    //           setter: <TextSetter />,
    //         },
    //         {
    //           name: 'hasClear',
    //           title: '允许清空',
    //           display: 'inline',
    //           // supportVariable: true,
    //           initialValue: true,
    //           tip: '设计规范规定，不建议修改',
    //           setter: <BoolSetter />,
    //         },
    //         {
    //           name: ID_NAME,
    //           setter: <TextSetter />,
    //           hidden() {
    //             return true;
    //           },
    //         },
    //       ]}
    //     />
    //   ),
    // },
    {
      name: '_bindTable',
      title: '关联表格',
      mutator(value) {
        if (value) {
          // const nodeDocument = node.document || node.page;
          // const NodeCache = nodeDocument.getRootNodeVisitor(
          //   'NodeCache',
          // );
          // const tableNode = NodeCache?.getNodeById(value);

          // const tableNode = this.designer?.currentDocument?.getNode(value)
          // if(tableNode) {
          //   const _dataSourceName = this.getNode().getPropValue('_dataSourceName');
          //   if(_dataSourceName) {
          //     tableNode.setPropValue("_bindFilterDataSourceName", _dataSourceName)
          //   }
          // }

          const tableNode = this.getNode?.()?.document?.getNode?.(value);
          if (tableNode) {
            const _dataSourceName =
              this?.parent?.getPropValue?.('_dataSourceName');
            if (_dataSourceName) {
              tableNode.setPropValue(
                '_bindFilterDataSourceName',
                _dataSourceName,
              );
            }
          }
        }
      },
      setter(prop) {
        const options = [];
        prop?.getNode?.()?.document?.nodesMap?.forEach((item) => {
          if (item.getPropValue('isCnTable')) {
            const id = item.id || '';
            const tableName = item?.propsData?.tableName || '';
            // let title = id;
            // if (title.slice(0, 4) === 'node') {
            //   title = title.replace('node', '表格');
            // }
            const title = `表格_${tableName}`;
            options.push({
              title,
              value: id,
            });
          }
        });
        return {
          componentName: 'CnSelectSetter',
          props: {
            options,
            selectProps: {
              hasClear: true,
            },
          },
        };
        // // 兼容Vision低版本
        // const nodeDocument =  this.getNode().document || this.getNode().page;
        // const NodeCache = nodeDocument.getRootNodeVisitor(
        //   'NodeCache',
        // );
        // const { nodeList } = NodeCache
        // const options = nodeList
        //   .filter(x => {
        //     // 新方案：props 里的 isTable 来标记是否是表格类型，需要做联动
        //     return x.getPropValue('isCnTable');
        //   })
        //   .map(x => {
        //     let id = x.id || '';
        //     let title = id;
        //     if(title.slice(0,4) === 'node'){
        //       title = title.replace('node','表格')
        //     }
        //     return {
        //       title,
        //       value: id,
        //     }
        //   });
        // return <SelectSetter
        //   options={options}
        //   hasClear={true}
        // />
      },
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      name: 'filterStyle',
      display: 'accordion',
      title: '筛选栏样式',
      collapsed: true,
      extraProps: {
        defaultCollapsed: true,
      },
      setter: {
        componentName: 'ObjectSetter',
        props: {
          config: {
            items: [
              {
                title: '展开/收起',
                name: 'showFolder',
                defaultValue: true,
                setter: 'BoolSetter',
              },
              {
                title: '以tag形式展示选中项',
                name: 'showSelected',
                defaultValue: false,
                setter: 'BoolSetter',
              },
              {
                title: '筛选栏排序',
                name: 'enableConfig',
                defaultValue: false,
                setter: 'BoolSetter',
              },
              {
                title: '我的查询条件',
                name: 'enableSaveSelected',
                defaultValue: false,
                setter: 'BoolSetter',
              },
              {
                title: '点击重置后是否需要自动查询',
                name: 'afterResetNeedQuery',
                defaultValue: true,
                setter: 'BoolSetter',
              },
              {
                title: '展示底部分割线',
                name: 'showBottomLine',
                defaultValue: true,
                setter: 'BoolSetter',
              },
              {
                title: '默认可见行数',
                name: 'maxVisibleRow',
                setter: 'NumberSetter',
              },
              {
                title: '开启查询条件暂存',
                name: 'cacheSearch',
                setter: 'BoolSetter',
              },
              {
                name: 'size',
                title: '尺寸',
                display: 'inline',
                setter: {
                  componentName: 'MixedSetter',
                  props: {
                    setters: [
                      {
                        componentName: 'RadioGroupSetter',
                        props: {
                          options: [
                            { title: '小', value: 'small' },
                            { title: '中', value: 'medium' },
                            { title: '大', value: 'large' },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              getLabelAlignSetterSnippet(),
              {
                name: 'hideButton',
                title: '隐藏操作按钮',
                setter: 'BoolSetter',
              },
              {
                name: 'removeEmptyLabel',
                title: '标签为空时自动收紧',
                setter: 'BoolSetter',
              },
            ],
          },
        },
      },
    },
    ...createFormDefaultValueSetters({
      position: DisplayPosition.filter,
      afterRequestSuccessPosition:
        ButtonPosition.filterDefaultValueAfterRequestSuccess,
    }),
    ...createEventSetters({
      position: ButtonPosition.filterEvent,
      initialValue: {
        optType: 'flowAction',
      },
      title: '配置筛选栏的回调',
    }),
    // {
    //   name: '_dataSource',
    //   title: '数据源',
    //   initialValue: {
    //     type: 'variable',
    //     variable: 'state.dp2',
    //   },
    //   display: 'none',
    // },
    // {
    //   title: '样式',
    //   type: 'group',
    //   display: 'accordion',
    //   items: [
    //     {
    //       name: 'hidden',
    //       title: '是否隐藏',
    //       display: 'inline',
    //       supportVariable: true,
    //       initialValue: false,
    //       setter: <BoolSetter />,
    //     },
    //     {
    //       name: 'collapse',
    //       title: '支持展开收缩',
    //       display: 'inline',
    //       supportVariable: true,
    //       initialValue: true,
    //       setter: <BoolSetter />,
    //     },
    //     {
    //       name: 'collapse',
    //       title: '默认展开',
    //       display: 'inline',
    //       supportVariable: true,
    //       initialValue: true,
    //       setter: <BoolSetter />,
    //     },
    //   ],
    // },
    {
      name: 'extendButtons',
      title: '筛选栏扩展按钮',
      display: 'accordion',
      collapsed: true,
      initialValue: [],
      setter: createButtonListSetters({
        position: ButtonPosition.filterExtendButton,
      }),
    },
    ...getBizExtendPrototype({
      componentName: 'CnFilterPro',
    }),
    {
      title: '一码多端配置项',
      name: 'mobileProps',
      display: 'accordion',
      setter: getObjectSetterSnippet({
        items: [
          {
            name: 'positionFix',
            title: {
              label: (
                <div
                  onClick={() =>
                    window.open(
                      'https://alidocs.dingtalk.com/i/nodes/bxgzX5wq4YoJPAb3wyBD8Ry2OB79ALPD?utm_scene=team_space&iframeQuery=anchorId%3Duu_ljqvj3cqxdgwqryyby',
                    )
                  }
                >
                  间距&宽度干预处理
                  <CnIcon type='icon-help' />
                </div>
              ),
            },
            tip: '标准FTP场景推荐开启，非标准推荐关闭，点击查看文档',
            display: 'inline',
            defaultValue: true,
            setter: 'BoolSetter',
          },
        ],
      }),
    },
    {
      title: '高级配置',
      type: 'group',
      collapsed: true,
      display: 'accordion',
      items: [
        {
          name: '_nodeId',
          title: '节点 ID',
          display: 'inline',
          initialValue() {
            return this.getNode().id;
          },
          setter: <IdSetter />,
        },
        {
          name: 'handleProps',
          title: '手动设置组件props',
          display: 'inline',
          setter: getJSExpressionPrototype({
            type: 'props',
          }),
        },
        {
          name: '_dataSource',
          title: '数据源',
          display: 'inline',
          supportVariable: false,
          mutator(value) {
            const node = this.getProps().getNode();
            const result = getDsNameFromVariable(value);
            if (result) {
              node.setPropValue('_dataSourceName', result);
            }
          },
          initialValue(value) {
            const v = this.getValue();
            // if (value) {
            //   return value;
            // }
            // if(Engine?.Exchange?.hoveringNode){
            //   const node = this.getNode();
            //   const {componentName} = node;
            //   const currentDataSource = node.getPropValue('_dataSource');
            const { componentName } = this;
            const currentDataSource = this.getPropValue('_dataSource');
            if (!currentDataSource && !v) {
              let dataSourceList = [];
              dataSourceList = getDataSourceList();
              let index = '';
              const first = dataSourceList?.find(
                (item) => item.value === `${componentName}`,
              );
              if (first) {
                index = generateIndex(dataSourceList, componentName);
              }
              if (Engine) {
                const componentPrototype =
                  Engine?.designer?.getComponentMeta?.(
                    componentName,
                  )?.prototype;
                const dataSource = Engine?.context?.getManager('dataPool');
                const ds = dataSource?.addItem({
                  description: `${
                    componentPrototype?.options?.title || componentName
                  }${index}的数据源`,
                  dpType: 'VALUE',
                  id: '',
                  initialData: '',
                  isGlobal: false,
                  name: `${componentName}${index}`,
                  protocal: 'VALUE',
                });
                if (ds?.name) {
                  // this.setPropValue('_dataSourceName',ds.name)
                  this.parent?.setPropValue?.('_dataSourceName', ds.name);
                  return {
                    type: 'variable',
                    variable: `state.${ds.name}`,
                  };
                }
              }
            }
            // return currentDataSource;
            // }
            // return this.initialData || '';
          },
          setter: <DataSourceSetter />,
        },
        {
          name: '_dataSourceName',
          title: '数据源名称',
          display: 'none',
          // supportVariable: true,
          initialValue() {
            const value = this.parent?.getPropValue?.('_dataSourceName');
            if (!value) {
              const node = this.getNode();
              const dsExpr = node?.getPropValue('_dataSource');
              return getDsNameFromVariable(dsExpr);
            }
            return value;
          },
        },
        // {
        //   name: 'ignore',
        //   title: '重置时忽略字段',
        //   display: 'inline',
        //   supportVariable: true,
        //   initialValue: false,
        //   setter: <SelectSetter
        //     options={[{
        //       title: '输入框1',
        //       value: 'text1',
        //     }, {
        //       title: '下拉框1',
        //       value: 'select',
        //     }]}
        //     compact={false}
        //   />,
        // },
        {
          name: 'onGetStorage',
          title: '获取习惯(onGetStorage)',
          display: 'inline',
          setter: (
            <ActionSetter
              supportTypes={['page']}
              defaultCode={`/**
* onGetStorage
*
* @param key string
* @param type string
*/
function onGetStorage(key, type) {

}`}
              defaultActionName='onGetStorage'
            />
          ),
        },
        {
          name: 'onSetStorage',
          title: '设置习惯(onSetStorage)',
          display: 'inline',
          setter: (
            <ActionSetter
              supportTypes={['page']}
              defaultCode={`/**
* onSetStorage
*
* @param key string
* @param type string
* @param values string
*/
function onSetStorage(key, type, values) {

}`}
              defaultActionName='onSetStorage'
            />
          ),
        },
        {
          name: 'isHighPerformance',
          title: {
            label: (
              <div>
                开启高性能
                <CnIcon type='icon-help' />
              </div>
            ),
          },
          display: 'none',
          tip: '注意：推荐在表单项大于20个且出现明显卡顿时开启,开启后查询需等待500ms',
          initialValue: false,
          setter: 'BoolSetter',
        },
        {
          name: 'isCnFilterPro',
          title: '使用高级筛选栏(请勿使用)',
          display: 'none',
          initialValue: true,
          setter: 'BoolSetter',
        },
      ],
    },
    //     {
    //       name: 'events',
    //       title: '事件',
    //       display: 'accordion',
    //       setter:<EventSetter
    //         events={[
    //           {
    //             name: 'onSubmit',
    //             title: '点击查询时',
    //             initialValue: `/**
    // * filter onSubmit
    // * @param
    // */
    // function onSubmit(value) {
    //   console.log('onSubmit', value);
    // }`,
    //           },
    //         ]}
    //       />
    //     },
  ],
});

export default filterBundle;
